import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { isCordova } from '../../util/mobile/deviceDetection';

// The messages rendered below embed raw HTML. ICU would read those tags as tag
// nodes, and it cannot parse a tag carrying attributes (<a href="…">) at all, so
// every tag is apostrophe-quoted in the catalogs ('<b>'…'</b>') to keep the files
// compilable by formatjs and each message a single literal node. A leftover tag
// node would throw once the catalogs ship as AST, making react-intl render the
// bare message id.
//
// The quoting only disappears if the ICU parser actually runs. `formatMessage`
// short-circuits on a "hot path" that returns the catalog string verbatim when
// no values argument is passed (see @formatjs/intl `formatMessage`), which would
// leak the apostrophes into the rendered HTML. Passing an (empty) values object
// forces the parser to run, so the message resolves to a single literal node and
// the HTML comes out exactly as authored.
const NO_VALUES = {};

// Below 1200 px the text would run over the whole tablet width.
const blockSx = (theme) => ({
  my: 2,
  maxWidth: { xs: theme.tokens.textMaxWidth, lg: 'none' },
});

const SectionWhyVanSite = () => {
  const intl = useIntl();

  if (isCordova()) return null;

  return (
    <Container maxWidth="xl" sx={{ py: 8 }}>
      <Stack key="1" spacing={2} sx={blockSx}>
        <Typography component="h2" variant="h3">
          <FormattedMessage id="SectionWhyVanSite.header" />
        </Typography>

        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVansite.introduction' }, NO_VALUES),
          }}
          key="0"
        />

        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.subHeader" />
        </Typography>

        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.subHeader2" />
        </Typography>

        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.largeSelection' }, NO_VALUES),
          }}
        />

        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.topRecommendationsHeader" />
        </Typography>
        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.reviews' }, NO_VALUES),
          }}
        />
      </Stack>

      <Stack key="2" spacing={2} sx={blockSx}>
        <Typography component="h3" variant="p">
          <FormattedMessage id="SectionWhyVanSite.sharePlace.header" />
        </Typography>

        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.sharePlace.appBooking" />
        </Typography>
        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.sharePlace.text' }, NO_VALUES),
          }}
        />

        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.realtime" />
        </Typography>

        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.realtime.text' }, NO_VALUES),
          }}
        />
      </Stack>

      <Stack key="4" spacing={2} sx={blockSx}>
        <Typography component="p" variant="h3">
          <FormattedMessage id="SectionWhyVanSite.app.header" />
        </Typography>
        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.app.mapHeader" />
        </Typography>

        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.app.text' }, NO_VALUES),
          }}
        />

        <Typography component="p" variant="h5">
          <FormattedMessage id="SectionWhyVanSite.app.filter" />
        </Typography>

        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.app.filter.text' }, NO_VALUES),
          }}
        />

        <Typography
          component="p"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'SectionWhyVanSite.app.free.text' }, NO_VALUES),
          }}
        />
      </Stack>
      <Stack key="5" spacing={2} sx={blockSx}>
        <Typography component="p" variant="h3">
          <FormattedMessage id="SectionWhyVanSite.aboutUs.header" />
        </Typography>
        <Typography component="p" variant="body1">
          <FormattedMessage id="SectionWhyVanSite.aboutUs.text" />
        </Typography>
      </Stack>
    </Container>
  );
};
export default SectionWhyVanSite;
